import { CIcon } from '~/icons/types'

export const ciSnowsports: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'm23.893 15.961-.16-.385a.5.5 0 0 0-.65-.27.516.516 0 0 0-.262.664l.16.385a.348.348 0 0 1-.038.342.72.72 0 0 1-.616.294h-.978l-2.416-3.3h3.06a1.253 1.253 0 0 0 1.166-.784 1.308 1.308 0 0 0-.25-1.41l-.027-.029-5.83-5.34a.484.484 0 0 0-.7.038.512.512 0 0 0 .038.712l1.988 1.823-3.507 1.187h-2.94l-5.5-1.963a1.215 1.215 0 0 0-1.241.226.991.991 0 0 0-.3.992.674.674 0 0 0 .056.14l.38.63a3.684 3.684 0 0 0-2.9 1.934.23.23 0 0 0-.023.062L1.89 13.42a2.31 2.31 0 0 0 .362 4.581h8.307a2.277 2.277 0 0 0 2.248-2.189h3.465a.49.49 0 0 0 .366-.169L18 14.09l2.13 2.9h-6.1a.505.505 0 0 0 0 1.01h8.308a1.7 1.7 0 0 0 1.438-.74 1.392 1.392 0 0 0 .117-1.298ZM6.088 8.873s.01.005.014.005l2.83 1.006H6.475l-.6-.992a.247.247 0 0 1 .214-.019Zm4.467 8.113H2.247a1.295 1.295 0 0 1 0-2.589h8.308a1.294 1.294 0 0 1 0 2.59Zm7.2-4.133-.052.057a.49.49 0 0 0-.08.092l-1.577 1.8h-3.418a2.254 2.254 0 0 0-2.073-1.41H2.943l.38-1.117A2.79 2.79 0 0 1 5.85 10.9h9.106a.59.59 0 0 0 .155-.024l4.119-1.395 2.98 2.733a.3.3 0 0 1 .048.3.273.273 0 0 1-.26.173H18.12a.49.49 0 0 0-.366.167h.002Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'snowsports',
  type: 'thin'
}
